import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SideBarProps } from "../types/types";
import { RxDashboard } from "react-icons/rx";
import {
  TbArrowsExchange,
  TbLogout2,
  TbPackages,
  TbTruckLoading,
} from "react-icons/tb";
import {
  FaPersonCircleCheck,
  FaQuestion,
  FaRegNewspaper,
  FaUserDoctor,
  FaUsers,
  FaChevronDown,
  FaChevronRight,
} from "react-icons/fa6";
import {
  IoDocumentsOutline,
  IoPersonAddOutline,
  IoStorefrontOutline,
} from "react-icons/io5";
import {
  MdChecklist,
  MdCreditScore,
  MdDomainVerification,
  MdEditDocument,
  MdIncompleteCircle,
  MdKeyboardDoubleArrowLeft,
  MdOutlineAccountBalance,
  MdOutlineAssignment,
  MdOutlineDeliveryDining,
  MdOutlineHistory,
  MdOutlineMoney,
  MdOutlinePersonOff,
  MdOutlineRealEstateAgent,
  MdOutlineRestaurantMenu,
  MdOutlineSwitchAccount,
  MdOutlineManageAccounts,
  MdOutlineWarehouse,
  MdSchool,
  MdInventory,
} from "react-icons/md";
import { HiOutlineCommandLine } from "react-icons/hi2";
import { GoCrossReference, GoMoveToEnd } from "react-icons/go";
import { RiCustomerService2Line, RiGovernmentLine } from "react-icons/ri";
import { BsBank, BsPersonArmsUp } from "react-icons/bs";
import { BiMessageDetail } from "react-icons/bi";
import DietitianMessage from "./modals/DietitianMessage";
import ChangePassword from "./modals/ChangePassword";
import { useAppDispatch } from "../redux/hooks";
import { verificationStageOne, verificationStageTwo } from "../redux/thunk";
import { LuLineChart } from "react-icons/lu";
import { HiOutlineSpeakerphone } from "react-icons/hi";

const SideBar = ({
  tabNavigation,
  toggleTabNavigation,
  openModal,
  role,
  setShowSidebar,
  setSrc,
}: SideBarProps) => {
  const navigate = useNavigate();
  const fullName = sessionStorage.getItem("name");
  const userEmail = sessionStorage.getItem("userEmail");
  const adminLevel = sessionStorage.getItem("adminLevel");
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [clientName, setClientName] = useState("");
  const [expandedItems, setExpandedItems] = useState<{
    [key: string]: boolean;
  }>({});
  const dispatch = useAppDispatch();
  const role2 = "dietitia";

  const clientMsg = [
    {
      name: "Jenifer o",
      img: "/assets/picture.jpg",
      request: [],
    },
    {
      name: "Blessing o",
      img: "/assets/picture.jpg",
      request: [],
    },
    {
      name: "Ella P",
      img: "/assets/picture.jpg",
      request: [],
    },
    {
      name: "Grace P",
      img: "/assets/picture.jpg",
      request: [],
    },
    {
      name: "Motunrayo K",
      img: "/assets/picture.jpg",
      request: [],
    },
    {
      name: "Zen Ah",
      img: "/assets/picture.jpg",
      request: [],
    },
    {
      name: "Winnie D",
      img: "/assets/picture.jpg",
      request: [],
    },
    {
      name: "Feranmi J",
      img: "/assets/picture.jpg",
      request: [],
    },
  ];

  const tabs: any = [
    {
      title: (
        <div className="flex items-center">
          <RxDashboard className="w-6 h-6" />
          <span className="pl-2">Dashboard</span>
        </div>
      ),
      query: "dashboard",
    },
    {
      title: (
        <div className="flex items-center">
          <MdOutlineManageAccounts className="w-6 h-6" />
          <span className="pl-2">Account Management</span>
        </div>
      ),
      query: "dashboard/account-management",
    },
    {
      title: (
        <div className="flex items-center">
          <FaUsers className="w-6 h-6" />
          <span className="pl-2">Staff Management</span>
        </div>
      ),
      query: "dashboard/staff-management",
    },
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <HiOutlineSpeakerphone className="w-6 h-6" />
            <span className="pl-2">Push Notification</span>
          </div>
        ),
        query: "dashboard/push-notification",
      }
      : role && role.some((data: any) => data.role === "Push notification")
        ? {
          title: (
            <div className="flex items-center">
              <HiOutlineSpeakerphone className="w-6 h-6" />
              <span className="pl-2">Push Notification</span>
            </div>
          ),
          query: "dashboard/push-notification",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <FaRegNewspaper className="w-6 h-6" />
            <span className="pl-2">News Update</span>
          </div>
        ),
        query: "dashboard/news-update",
      }
      : role && role.some((data: any) => data.role === "News update")
        ? {
          title: (
            <div className="flex items-center">
              <FaRegNewspaper className="w-6 h-6" />
              <span className="pl-2">News Update</span>
            </div>
          ),
          query: "dashboard/news-update",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <BiMessageDetail className="w-6 h-6" />
            <span className="pl-2">Messages</span>
          </div>
        ),
        query: "dashboard/messages",
      }
      : role && role.some((data: any) => data.role === "Messages")
        ? {
          title: (
            <div className="flex items-center">
              <BiMessageDetail className="w-6 h-6" />
              <span className="pl-2">Messages</span>
            </div>
          ),
          query: "dashboard/messages",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdOutlineSwitchAccount className="w-6 h-6" />
            <span className="pl-2">User Interface</span>
          </div>
        ),
        subItems: [
          {
            title: "Web Visitors",
            query: "dashboard/web-visitors",
          },
          {
            title: "Feature Switch",
            query: "dashboard/feature-switch",
          },
        ],
      }
      : role && role.some((data: any) => data.role === "User Interface")
        ? {
          title: (
            <div className="flex items-center">
              <MdOutlineSwitchAccount className="w-6 h-6" />
              <span className="pl-2">User Interface</span>
            </div>
          ),
          subItems: [
            {
              title: "Web Visitors",
              query: "dashboard/web-visitors",
            },
            {
              title: "Feature Switch",
              query: "dashboard/feature-switch",
            },
          ],
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <TbPackages className="w-6 h-6" />
            <span className="pl-2">Special Offers</span>
          </div>
        ),
        query: "dashboard/packages",
      }
      : role && role.some((data: any) => data.role === "Packages")
        ? {
          title: (
            <div className="flex items-center">
              <TbPackages className="w-6 h-6" />
              <span className="pl-2">Packages</span>
            </div>
          ),
          query: "dashboard/packages",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <IoStorefrontOutline className="w-6 h-6" />
            <span className="pl-2">Store</span>
          </div>
        ),
        query: "dashboard/store",
      }
      : role && role.some((data: any) => data.role === "Store")
        ? {
          title: (
            <div className="flex items-center">
              <IoStorefrontOutline className="w-6 h-6" />
              <span className="pl-2">Store</span>
            </div>
          ),
          query: "dashboard/store",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <IoStorefrontOutline className="w-6 h-6" />
            <span className="pl-2">Walk-in Management</span>
          </div>
        ),
        subItems: [
          {
            title: "Dashboard",
            query: "dashboard/walk-in/dashboard",
          },
          {
            title: "Cash Flow",
            query: "dashboard/walk-in/cash-flow",
          },
          {
            title: "Order Management",
            query: "dashboard/walk-in/order-management",
          },
          {
            title: "Live Cart",
            query: "dashboard/walk-in/live-cart",
          },
          {
            title: "Inventory",
            query: "dashboard/walk-in/inventory",
          },
          {
            title: "Calendar",
            query: "dashboard/walk-in/calendar",
          },
          {
            title: "Agent Management",
            query: "dashboard/walk-in/agent-management",
          },
          {
            title: "Pickup Locations",
            query: "dashboard/walk-in/pickup-locations",
          },
        ],
      }
      : role && role.some((data: any) => data.role === "Walk-in Management")
        ? {
          title: (
            <div className="flex items-center">
              <IoStorefrontOutline className="w-6 h-6" />
              <span className="pl-2">Walk-in Management</span>
            </div>
          ),
          subItems: [
            {
              title: "Dashboard",
              query: "dashboard/walk-in/dashboard",
            },
            {
              title: "Cash Flow",
              query: "dashboard/walk-in/cash-flow",
            },
            {
              title: "Order Management",
              query: "dashboard/walk-in/order-management",
            },
            {
              title: "Live Cart",
              query: "dashboard/walk-in/live-cart",
            },
            {
              title: "Inventory",
              query: "dashboard/walk-in/inventory",
            },
            {
              title: "Calendar",
              query: "dashboard/walk-in/calendar",
            },
            {
              title: "Agent Management",
              query: "dashboard/walk-in/agent-management",
            },
            {
              title: "Pickup Locations",
              query: "dashboard/walk-in/pickup-locations",
            },
          ],
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdInventory className="w-6 h-6" />
            <span className="pl-2">Sales Inventory</span>
          </div>
        ),
        subItems: [
          {
            title: "Overview",
            query: "dashboard/sales-inventory",
          },
          // {
          //   title: "Customer Orders",
          //   query: "dashboard/sales-inventory/orders",
          // },
          {
            title: "Products Needed",
            query: "dashboard/sales-inventory/needed",
          },
          // {
          //   title: "Recently Updated",
          //   query: "dashboard/sales-inventory/updated",
          // },
          {
            title: "Email Management",
            query: "dashboard/sales-inventory/emails",
          },
          {
            title: "Threshold Settings",
            query: "dashboard/sales-inventory/thresholds",
          },
        ],
      }
      : role && role.some((data: any) => data.role === "Sales Inventory")
        ? {
          title: (
            <div className="flex items-center">
              <MdInventory className="w-6 h-6" />
              <span className="pl-2">Sales Inventory</span>
            </div>
          ),
          subItems: [
            {
              title: "Overview",
              query: "dashboard/sales-inventory",
            },
            // {
            //   title: "Customer Orders",
            //   query: "dashboard/sales-inventory/orders",
            // },
            {
              title: "Products Needed",
              query: "dashboard/sales-inventory/needed",
            },
            // {
            //   title: "Recently Updated",
            //   query: "dashboard/sales-inventory/updated",
            // },
            {
              title: "Email Management",
              query: "dashboard/sales-inventory/emails",
            },
            {
              title: "Threshold Settings",
              query: "dashboard/sales-inventory/thresholds",
            },
          ],
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <IoDocumentsOutline className="w-6 h-6" />
            <span className="pl-2">Order Processing</span>
          </div>
        ),
        query: "dashboard/order-processing",
      }
      : role && role.some((data: any) => data.role === "Order Processing")
        ? {
          title: (
            <div className="flex items-center">
              <IoDocumentsOutline className="w-6 h-6" />
              <span className="pl-2">Order Processing</span>
            </div>
          ),
          query: "dashboard/order-processing",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdOutlineDeliveryDining className="w-6 h-6" />
            <span className="pl-2">Riders</span>
          </div>
        ),
        query: "dashboard/riders",
      }
      : role && role.some((data: any) => data.role === "Riders")
        ? {
          title: (
            <div className="flex items-center">
              <MdOutlineDeliveryDining className="w-6 h-6" />
              <span className="pl-2">Riders</span>
            </div>
          ),
          query: "dashboard/riders",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdOutlineDeliveryDining className="w-6 h-6" />
            <span className="pl-2">Logistics</span>
          </div>
        ),
        subItems: [
          {
            title: "Overview",
            query: "dashboard/logistics",
          },
          {
            title: "Rider Management",
            query: "dashboard/logistics/rider-management",
          },
          {
            title: "Order Management",
            subItems: [
              {
                title: "Order Dispatch",
                query: "dashboard/logistics/order-management/order-dispatch",
              },
              {
                title: "Real Time Tracking",
                query:
                  "dashboard/logistics/order-management/real-time-tracking",
              },
            ],
          },
          {
            title: "Finance",
            subItems: [
              // {
              //   title: "Earnings and Payouts",
              //   query: "dashboard/logistics/earnings-payout",
              // },
              {
                title: "Payout Requests",
                query: "dashboard/logistics/payout-requests",
              },
            ],
          },
          {
            title: "Issues & Communication",
            subItems: [
              {
                title: "Issues",
                query: "dashboard/logistics/issues-communication/issues",
              },
              {
                title: "Communication Center",
                query:
                  "dashboard/logistics/issues-communication/communication-center",
              },
            ],
          },
          {
            title: "Performance Monitoring",
            query: "dashboard/logistics/performance-monitoring",
          },
          {
            title: "System Settings",
            query: "dashboard/logistics/system-settings",
          },
          {
            title: "User Role Management",
            query: "dashboard/logistics/user-role-management",
          },
          {
            title: "Logistics",
            query: "dashboard/logistics/logistics",
          },
        ],
      }
      : role && role.some((data: any) => data.role === "Logistics")
        ? {
          title: (
            <div className="flex items-center">
              <MdOutlineDeliveryDining className="w-6 h-6" />
              <span className="pl-2">Logistics</span>
            </div>
          ),
          subItems: [
            {
              title: "Overview",
              query: "dashboard/logistics",
            },
            {
              title: "Rider Management",
              query: "dashboard/logistics/rider-management",
            },
          ],
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdOutlineRestaurantMenu className="w-6 h-6" />
            <span className="pl-2">Restaurants</span>
          </div>
        ),
        subItems: [
          {
            title: "Overview",
            query: "dashboard/restaurants",
          },
          {
            title: "Operations",
            subItems: [
              {
                title: "Restaurant Management",
                query: "dashboard/operations/restaurant-management",
              },
              {
                title: "Order Monitoring",
                query: "dashboard/operations/order-monitoring",
              },
              {
                title: "Menu Oversight",
                query: "dashboard/operations/menu-oversight",
              },
            ],
          },
          {
            title: "Finance & Analytics",
            subItems: [
              {
                title: "Finance and Payouts",
                query: "dashboard/restaurants/finance-analytics",
              },
              {
                title: "Fee Management",
                query: "dashboard/restaurants/fee-management",
              },
              {
                title: "Reports and Analytics",
                query: "dashboard/restaurants/reports-analytics",
              },
            ],
          },
          {
            title: "Issues & Communications",
            subItems: [
              {
                title: "Communication Center",
                query: "dashboard/restaurants/communication-center",
              },
              {
                title: "Issues",
                query: "dashboard/restaurants/issues",
              },
            ],
          },
          {
            title: "Pending Orders",
            query: "dashboard/restaurants/pending-orders",
          },
        ],
      }
      : role && role.some((data: any) => data.role === "Restaurants")
        ? {
          title: (
            <div className="flex items-center">
              <MdOutlineRestaurantMenu className="w-6 h-6" />
              <span className="pl-2">Restaurants</span>
            </div>
          ),
          subItems: [
            {
              title: "Overview",
              query: "dashboard/restaurants/overview",
            },
            {
              title: "Operations",
              subItems: [
                {
                  title: "Restaurant Management",
                  query: "dashboard/operations/restaurant-management",
                },
                {
                  title: "Order Monitoring",
                  query: "dashboard/operations/order-monitoring",
                },
                {
                  title: "Menu Oversight",
                  query: "dashboard/operations/menu-oversight",
                },
              ],
            },
            {
              title: "Finance & Analytics",
              subItems: [
                {
                  title: "Finance and Payouts",
                  query: "dashboard/restaurants/finance-analytics",
                },
                {
                  title: "Fee Management",
                  query: "dashboard/restaurants/fee-management",
                },
                {
                  title: "Reports and Analytics",
                  query: "dashboard/restaurants/reports-analytics",
                },
              ],
            },
            {
              title: "Issues & Communications",
              subItems: [
                {
                  title: "Communication Center",
                  query: "dashboard/restaurants/communication-center",
                },
                {
                  title: "Issues",
                  query: "dashboard/restaurants/issues",
                },
              ],
            },
            {
              title: "Pending Orders",
              query: "dashboard/restaurants/pending-orders",
            },
          ],
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdOutlineWarehouse className="w-6 h-6" />
            <span className="pl-2">Ware House Mgt.</span>
          </div>
        ),
        query: "dashboard/warehouse-management",
      }
      : role && role.some((data: any) => data.role === "Warehouse Management")
        ? {
          title: (
            <div className="flex items-center">
              <MdOutlineWarehouse className="w-6 h-6" />
              <span className="pl-2">Ware House Mgt.</span>
            </div>
          ),
          query: "dashboard/warehouse-management",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <GoCrossReference className="w-6 h-6" />
            <span className="pl-2">Referrals</span>
          </div>
        ),
        query: "dashboard/referrals",
      }
      : role && role.some((data: any) => data.role === "Referrals")
        ? {
          title: (
            <div className="flex items-center">
              <GoCrossReference className="w-6 h-6" />
              <span className="pl-2">Referrals</span>
            </div>
          ),
          query: "dashboard/referrals",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <LuLineChart className="w-6 h-6" />
            <span className="pl-2">Spin and Win</span>
          </div>
        ),
        query: "dashboard/spin-and-win",
      }
      : role && role.some((data: any) => data.role === "Spin and Win")
        ? {
          title: (
            <div className="flex items-center">
              <LuLineChart className="w-6 h-6" />
              <span className="pl-2">Spin and Win</span>
            </div>
          ),
          query: "dashboard/spin-and-win",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <FaUserDoctor className="w-6 h-6" />
            <span className="pl-2">Dietitians</span>
          </div>
        ),
        query: "dashboard/dietitians",
      }
      : role && role.some((data: any) => data.role === "Dietitians")
        ? {
          title: (
            <div className="flex items-center">
              <FaUserDoctor className="w-6 h-6" />
              <span className="pl-2">Dietitians</span>
            </div>
          ),
          query: "dashboard/dietitians",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <BsPersonArmsUp className="w-6 h-6" />
            <span className="pl-2">Vendors</span>
          </div>
        ),
        query: "dashboard/vendors",
      }
      : role && role.some((data: any) => data.role === "Vendors")
        ? {
          title: (
            <div className="flex items-center">
              <BsPersonArmsUp className="w-6 h-6" />
              <span className="pl-2">Vendors</span>
            </div>
          ),
          query: "dashboard/vendors",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <FaPersonCircleCheck className="w-6 h-6" />
            <span className="pl-2">Staff</span>
          </div>
        ),
        query: "dashboard/staff",
      }
      : role && role.some((data: any) => data.role === "Staff")
        ? {
          title: (
            <div className="flex items-center">
              <FaPersonCircleCheck className="w-6 h-6" />
              <span className="pl-2">Staff</span>
            </div>
          ),
          query: "dashboard/staff",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <TbTruckLoading className="w-6 h-6" />
            <span className="pl-2">Operations</span>
          </div>
        ),
        query: "dashboard/operations",
      }
      : role && role.some((data: any) => data.role === "Operations")
        ? {
          title: (
            <div className="flex items-center">
              <TbTruckLoading className="w-6 h-6" />
              <span className="pl-2">Operations</span>
            </div>
          ),
          query: "dashboard/operations",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdOutlineAssignment className="w-6 h-6" />
            <span className="pl-2">Assignment</span>
          </div>
        ),
        query: "dashboard/assignment",
      }
      : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdOutlineAccountBalance className="w-6 h-6" />
            <span className="pl-2">Virtual Account</span>
          </div>
        ),
        query: "dashboard/virtual-account",
      }
      : role && role.some((data: any) => data.role === "Virtual Account")
        ? {
          title: (
            <div className="flex items-center">
              <MdOutlineAccountBalance className="w-6 h-6" />
              <span className="pl-2">Virtual Account</span>
            </div>
          ),
          query: "dashboard/virtual-account",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        text: "verification",
        title: (
          <div className="flex items-center">
            <MdDomainVerification className="w-6 h-6" />
            <span className="pl-2">Verification</span>
          </div>
        ),
        subItems: [
          {
            title: "E-Verification 1",
            query: "dashboard/employed-verification1",
          },
          {
            title: "SE-Verification 1",
            query: "dashboard/self-employed-verification1",
          },
          {
            title: "S-Verification 1",
            query: "dashboard/student-verification1",
          },
        ],
      }
      : role &&
        (role.some((data: any) => data.role === "E-Verification 1") ||
          role.some((data: any) => data.role === "SE-Verification 1") ||
          role.some((data: any) => data.role === "S-Verification 1"))
        ? {
          text: "verification",
          title: (
            <div className="flex items-center">
              <MdDomainVerification className="w-6 h-6" />
              <span className="pl-2">Verification</span>
            </div>
          ),
          subItems: [
            ...(role.some((data: any) => data.role === "E-Verification 1")
              ? [
                {
                  title: "E-Verification 1",
                  query: "dashboard/employed-verification1",
                },
              ]
              : []),
            ...(role.some((data: any) => data.role === "SE-Verification 1")
              ? [
                {
                  title: "SE-Verification 1",
                  query: "dashboard/self-employed-verification1",
                },
              ]
              : []),
            ...(role.some((data: any) => data.role === "S-Verification 1")
              ? [
                {
                  title: "S-Verification 1",
                  query: "dashboard/student-verification1",
                },
              ]
              : []),
          ],
        }
        : {},
    adminLevel === "superadmin"
      ? {
        text: "oyoStateVerification",
        title: (
          <div className="flex items-center">
            <MdOutlineRealEstateAgent className="w-6 h-6" />
            <span className="pl-2"> Oyo State Verification</span>
          </div>
        ),
        query: "dashboard/oyo-state-verification",
      }
      : role && role.some((data: any) => data.role === "Oyo State Verification")
        ? {
          text: "oyoStateVerification",
          title: (
            <div className="flex items-center">
              <MdOutlineRealEstateAgent className="w-6 h-6" />
              <span className="pl-2"> Oyo State Verification</span>
            </div>
          ),
          query: "dashboard/oyo-state-verification",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        text: "docCheck",
        title: (
          <div className="flex items-center">
            <IoDocumentsOutline className="w-6 h-6" />
            <span className="pl-2">Document Check</span>
          </div>
        ),
        query: "dashboard/document-check",
      }
      : role && role.some((data: any) => data.role === "Document Check")
        ? {
          text: "docCheck",
          title: (
            <div className="flex items-center">
              <IoDocumentsOutline className="w-6 h-6" />
              <span className="pl-2">Document Check</span>
            </div>
          ),
          query: "dashboard/document-check",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        text: "oyoDocCheck",
        title: (
          <div className="flex items-center">
            <MdEditDocument className="w-6 h-6" />
            <span className="pl-2">Oyo Document Check</span>
          </div>
        ),
        query: "dashboard/oyo-document-check",
      }
      : role && role.some((data: any) => data.role === "Oyo Document Check")
        ? {
          text: "oyoDocCheck",
          title: (
            <div className="flex items-center">
              <MdEditDocument className="w-6 h-6" />
              <span className="pl-2">Oyo Document Check</span>
            </div>
          ),
          query: "dashboard/oyo-document-check",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        text: "lagosDocCheck",
        title: (
          <div className="flex items-center">
            <MdEditDocument className="w-6 h-6" />
            <span className="pl-2">Lagos Document Check</span>
          </div>
        ),
        query: "dashboard/lagos-document-check",
      }
      : role && role.some((data: any) => data.role === "Lagos Document Check")
        ? {
          text: "lagosDocCheck",
          title: (
            <div className="flex items-center">
              <MdEditDocument className="w-6 h-6" />
              <span className="pl-2">Lagos Document Check</span>
            </div>
          ),
          query: "dashboard/lagos-document-check",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        text: "privateOrgDocCheck",
        title: (
          <div className="flex items-center">
            <MdEditDocument className="w-6 h-6" />
            <span className="pl-2">Org Document Check</span>
          </div>
        ),
        subItems: [
          {
            title: "Church Document Check",
            query: "dashboard/church-document-check",
          },
          {
            title: "Organization Document Check",
            query: "dashboard/private-org-document-check",
          },
        ],
      }
      : role && role.some((data: any) => data.role === "Org Document Check")
        ? {
          text: "privateOrgDocCheck",
          title: (
            <div className="flex items-center">
              <MdEditDocument className="w-6 h-6" />
              <span className="pl-2">Org Document Check</span>
            </div>
          ),
          subItems: [
            {
              title: "Church Document Check",
              query: "dashboard/church-document-check",
            },
            {
              title: "Organization Document Check",
              query: "dashboard/private-org-document-check",
            },
          ],
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <RiGovernmentLine className="w-6 h-6" />
            <span className="pl-2">State Government</span>
          </div>
        ),
        query: "dashboard/state-government",
      }
      : role && role.some((data: any) => data.role === "State Government")
        ? {
          title: (
            <div className="flex items-center">
              <RiGovernmentLine className="w-6 h-6" />
              <span className="pl-2">State Government</span>
            </div>
          ),
          query: "dashboard/state-government",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <RiGovernmentLine className="w-6 h-6" />
            <span className="pl-2">Organizations</span>
          </div>
        ),
        subItems: [
          {
            title: "Churches",
            query: "dashboard/churches",
          },
          {
            title: "Organizations",
            query: "dashboard/private-organizations",
          },
        ],
      }
      : role && role.some((data: any) => data.role === "Organizations")
        ? {
          title: (
            <div className="flex items-center">
              <RiGovernmentLine className="w-6 h-6" />
              <span className="pl-2">Organizations</span>
            </div>
          ),
          subItems: [
            {
              title: "Churches",
              query: "dashboard/churches",
            },
            {
              title: "Organizations",
              query: "dashboard/private-organizations",
            },
          ],
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <BsBank className="w-6 h-6" />
            <span className="pl-2">MFBs</span>
          </div>
        ),
        query: "dashboard/micro-finance-banks",
      }
      : role && role.some((data: any) => data.role === "MFBs")
        ? {
          title: (
            <div className="flex items-center">
              <BsBank className="w-6 h-6" />
              <span className="pl-2">MFBs</span>
            </div>
          ),
          query: "dashboard/micro-finance-banks",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdCreditScore className="w-6 h-6" />
            <span className="pl-2">Credit Score</span>
          </div>
        ),
        query: "dashboard/credit-score",
      }
      : role && role.some((data: any) => data.role === "Credit Score")
        ? {
          title: (
            <div className="flex items-center">
              <MdCreditScore className="w-6 h-6" />
              <span className="pl-2">Credit Score</span>
            </div>
          ),
          query: "dashboard/credit-score",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdSchool className="w-6 h-6" />
            <span className="pl-2">Institute Upload</span>
          </div>
        ),
        query: "dashboard/institute-upload",
      }
      : role && role.some((data: any) => data.role === "Institute Upload")
        ? {
          title: (
            <div className="flex items-center">
              <MdSchool className="w-6 h-6" />
              <span className="pl-2">Institute Upload</span>
            </div>
          ),
          query: "dashboard/institute-upload",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdOutlineMoney className="w-6 h-6" />
            <span className="pl-2">Next Pay</span>
          </div>
        ),
        query: "dashboard/next-pay",
      }
      : role && role.some((data: any) => data.role === "Next Pay")
        ? {
          title: (
            <div className="flex items-center">
              <MdOutlineMoney className="w-6 h-6" />
              <span className="pl-2">Next Pay</span>
            </div>
          ),
          query: "dashboard/next-pay",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        text: "mandate",
        title: (
          <div className="flex items-center">
            <HiOutlineCommandLine className="w-6 h-6" />
            <span className="pl-2">Mandate</span>
          </div>
        ),
        subItems: [
          {
            title: "E-mandate",
            query: "dashboard/e-mandate",
          },
          {
            title: "Initiate Mandate",
            query: "dashboard/pending-emandate",
          },
        ],
      }
      : role &&
        (role.some((data: any) => data.role === "E-mandate") ||
          role.some((data: any) => data.role === "Initiate Mandate"))
        ? {
          text: "mandate",
          title: (
            <div className="flex items-center">
              <HiOutlineCommandLine className="w-6 h-6" />
              <span className="pl-2">Mandate</span>
            </div>
          ),
          subItems: [
            ...(role.some((data: any) => data.role === "E-mandate")
              ? [
                {
                  title: "E-mandate",
                  query: "dashboard/e-mandate",
                },
              ]
              : []),
            ...(role.some((data: any) => data.role === "Initiate Mandate")
              ? [
                {
                  title: "Initiate Mandate",
                  query: "dashboard/pending-emandate",
                },
              ]
              : []),
          ],
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdIncompleteCircle className="w-6 h-6" />
            <span className="pl-2">Incomplete Users</span>
          </div>
        ),
        query: "dashboard/incomplete-users",
      }
      : role && role.some((data: any) => data.role === "Incomplete Users")
        ? {
          title: (
            <div className="flex items-center">
              <MdIncompleteCircle className="w-6 h-6" />
              <span className="pl-2">Incomplete Users</span>
            </div>
          ),
          query: "dashboard/incomplete-users",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <FaUsers className="w-6 h-6" />
            <span className="pl-2">User Management</span>
          </div>
        ),
        subItems: [
          {
            title: "Agents",
            query: "dashboard/agents",
          },
          {
            title: "Users",
            query: "dashboard/users",
          },
          {
            title: "Users Details",
            query: "dashboard/user-details",
          },
          {
            title: "User Category",
            query: "dashboard/user-category",
          },
          {
            title: "User Category Table",
            query: "dashboard/user-category-table",
          },
          {
            title: "Transactions",
            query: "dashboard/transactions",
          },
          {
            title: "Paystack",
            query: "dashboard/paystack",
          },
        ],
      }
      : role &&
        (role.some((data: any) => data.role === "User Details") ||
          role.some((data: any) => data.role === "Users") ||
          role.some((data: any) => data.role === "User Category") ||
          role.some((data: any) => data.role === "Transactions") ||
          role.some((data: any) => data.role === "Paystack") ||
          role.some((data: any) => data.role === "Agents"))
        ? {
          title: (
            <div className="flex items-center">
              <FaUsers className="w-6 h-6" />
              <span className="pl-2">User Management</span>
            </div>
          ),
          subItems: [
            ...(role.some((data: any) => data.role === "Agents")
              ? [
                {
                  title: "Agents",
                  query: "dashboard/agents",
                },
              ]
              : []),
            ...(role.some((data: any) => data.role === "User Details")
              ? [
                {
                  title: "User Details",
                  query: "dashboard/user-details",
                },
              ]
              : []),
            ...(role.some((data: any) => data.role === "Users")
              ? [
                {
                  title: "Users",
                  query: "dashboard/users",
                },
              ]
              : []),
            ...(role.some((data: any) => data.role === "User Category")
              ? [
                {
                  title: "User Category",
                  query: "dashboard/user-category",
                },
              ]
              : []),
            ...(role.some((data: any) => data.role === "Transactions")
              ? [
                {
                  title: "Transactions",
                  query: "dashboard/transactions",
                },
              ]
              : []),
            ...(role.some((data: any) => data.role === "Paystack")
              ? [
                {
                  title: "Paystack",
                  query: "dashboard/paystack",
                },
              ]
              : []),
          ],
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <img src="/assets/users-icon.png" alt="Users Icon" className="w-6 h-6" />
            <span className="pl-2">Latest Registration</span>
          </div>
        ),
        subItems: [
          {
            title: "Outright Users",
            query: "dashboard/outright-users",
          },
          {
            title: "Flexible Users",
            query: "dashboard/flexible-users",
          },
        ],
      }
      : role && role.some((data: any) => data.role === "Latest Registration")
        ? {
          title: (
            <div className="flex items-center">
              <img src="/assets/users-icon.png" alt="Users Icon" className="w-6 h-6" />
              <span className="pl-2">Latest Registration</span>
            </div>
          ),
          subItems: [
            {
              title: "Outright Users",
              query: "dashboard/outright-users",
            },
            {
              title: "Flexible Users",
              query: "dashboard/flexible-users",
            },
          ],
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdChecklist className="w-6 h-6" />
            <span className="pl-2">Order Management</span>
          </div>
        ),
        subItems: [
          {
            title: "Orders",
            query: "dashboard/order-requests",
          },
          {
            title: "Lagos State Government Orders",
            query: "dashboard/lagos-state-government-orders",
          },
          {
            title: "Oyo State Government Orders",
            query: "dashboard/oyo-state-government-orders",
          },
          {
            title: "Church Orders",
            query: "dashboard/church-orders",
          },
          {
            title: "Organization Orders",
            query: "dashboard/private-org-orders",
          },
          {
            title: "Order History",
            query: "dashboard/order-history",
          },
        ],
      }
      : role &&
        (role.some((data: any) => data.role === "Orders") ||
          role.some(
            (data: any) =>
              data.role === "State Government Orders" ||
              data.role === "Lagos State Government Orders" ||
              data.role === "Oyo State Government Orders",
          ) ||
          role.some((data: any) => data.role === "Church Orders") ||
          role.some((data: any) => data.role === "Organization Orders") ||
          role.some((data: any) => data.role === "Order History"))
        ? {
          title: (
            <div className="flex items-center">
              <MdChecklist className="w-6 h-6" />
              <span className="pl-2">Order Management</span>
            </div>
          ),
          subItems: [
            ...(role.some((data: any) => data.role === "Orders")
              ? [
                {
                  title: "Orders",
                  query: "dashboard/order-requests",
                },
              ]
              : []),
            ...(role.some(
              (data: any) =>
                data.role === "State Government Orders" ||
                data.role === "Lagos State Government Orders",
            )
              ? [
                {
                  title: "Lagos State Government Orders",
                  query: "dashboard/lagos-state-government-orders",
                },
              ]
              : []),
            ...(role.some(
              (data: any) =>
                data.role === "State Government Orders" ||
                data.role === "Oyo State Government Orders",
            )
              ? [
                {
                  title: "Oyo State Government Orders",
                  query: "dashboard/oyo-state-government-orders",
                },
              ]
              : []),
            ...(role.some((data: any) => data.role === "Church Orders")
              ? [
                {
                  title: "Church Orders",
                  query: "dashboard/church-orders",
                },
              ]
              : []),
            ...(role.some((data: any) => data.role === "Organization Orders")
              ? [
                {
                  title: "Organization Orders",
                  query: "dashboard/private-org-orders",
                },
              ]
              : []),
            ...(role.some((data: any) => data.role === "Order History")
              ? [
                {
                  title: "Order History",
                  query: "dashboard/order-history",
                },
              ]
              : []),
          ],
        }
        : {},

    // end
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdOutlinePersonOff className="w-6 h-6" />
            <span className="pl-2">Risk Management</span>
          </div>
        ),
        subItems: [
          {
            title: "Defaulters",
            query: "dashboard/defaulters",
          },
          {
            title: "Blacklist",
            query: "dashboard/blacklist",
          },
        ],
      }
      : role && role.some((data: any) => data.role === "Defaulters")
        ? {
          title: (
            <div className="flex items-center">
              <MdOutlinePersonOff className="w-6 h-6" />
              <span className="pl-2">Risk Management</span>
            </div>
          ),
          subItems: [
            {
              title: "Defaulters",
              query: "dashboard/defaulters",
            },
            {
              title: "Blacklist",
              query: "dashboard/blacklist",
            },
          ],
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <IoPersonAddOutline className="w-6 h-6" />
            <span className="pl-2">Create Admin</span>
          </div>
        ),

        query: "dashboard/create-admin",
      }
      : role && role.some((data: any) => data.role === "Create Admin")
        ? {
          title: (
            <div className="flex items-center">
              <IoPersonAddOutline className="w-6 h-6" />
              <span className="pl-2">Create Admin</span>
            </div>
          ),

          query: "dashboard/create-admin",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <RiCustomerService2Line className="w-6 h-6" />
            <span className="pl-2">Customer Care</span>
          </div>
        ),
        query: "dashboard/customer-care",
      }
      : role && role.some((data: any) => data.role === "Customer Care")
        ? {
          title: (
            <div className="flex items-center">
              <RiCustomerService2Line className="w-6 h-6" />
              <span className="pl-2">Customer Care</span>
            </div>
          ),
          query: "dashboard/customer-care",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <FaQuestion className="w-6 h-6" />
            <span className="pl-2">FAQ</span>
          </div>
        ),
        query: "dashboard/faq",
      }
      : role && role.some((data: any) => data.role === "FAQ")
        ? {
          title: (
            <div className="flex items-center">
              <FaQuestion className="w-6 h-6" />
              <span className="pl-2">FAQ</span>
            </div>
          ),
          query: "dashboard/faq",
        }
        : {},
    adminLevel === "superadmin"
      ? {
        title: (
          <div className="flex items-center">
            <MdOutlineHistory className="w-6 h-6" />
            <span className="pl-2">Repayment History</span>
          </div>
        ),
        query: "dashboard/repayment-history",
      }
      : role && role.some((data: any) => data.role === "Repayment History")
        ? {
          title: (
            <div className="flex items-center">
              <MdOutlineHistory className="w-6 h-6" />
              <span className="pl-2">Repayment History</span>
            </div>
          ),
          query: "dashboard/repayment-history",
        }
        : {},
  ];

  const [currentTab, setCurrentTab] = useState(
    window.location.pathname.replace("/", "") || "dashboard",
  );

  const handleOverlayClick = () => {
    toggleTabNavigation();
  };

  const handleTabChange = (tab: any) => {
    setCurrentTab(tab);
    navigate(`/${tab}`);
    toggleTabNavigation();
    dispatch(verificationStageOne());
    dispatch(verificationStageTwo());
  };

  const handleClickMessage = (name: string) => {
    setShowMessageBox(true);
    setClientName(name);
  };

  const toggleExpanded = (itemKey: string) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  };

  return (
    <>
      {/* Mobile overlay behind sidebar */}
      <div
        className={`fixed inset-0 top-0 h-screen transition ease-in-out bg-black opacity-50 lg:hidden z-40 ${tabNavigation ? "block" : "hidden"
          }`}
        onClick={handleOverlayClick}
      ></div>
      <ul
        className={`fixed top-0 left-0 h-full z-50 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] shadow-md bg-white pt-10 px-6 pb-6
        w-[80%] max-w-xs md:w-[50%] lg:w-[260px]
        flex flex-col justify-between text-black
        transform transition-transform duration-300 ease-out
        ${tabNavigation
            ? "translate-x-0 pointer-events-auto"
            : "-translate-x-full pointer-events-none lg:translate-x-0 lg:pointer-events-auto"
          }`}
      >
        <div className="w-full mb-auto flex flex-col justify-between h-full">
          <div>
            {role2 === "dietitian".toLowerCase() ? (
              <div className="flex gap-2 items-center pb-2 mb-2 justify-center">
                <FaUsers className="w-8 h-8" />
                <p className="font-semibold text-2xl">User Count</p>
              </div>
            ) : (
              <div className="flex items-center gap-3 mb-8">
                <img
                  src="/assets/sidebar-logo.svg"
                  alt="logo"
                  className="w-10 h-10"
                />
                <div>
                  <h1 className="font-bold text-xl">
                    <span className="text-black">Food</span>
                    <span className="text-[#008060]">bank.</span>
                  </h1>
                  <p className="text-gray-400 text-sm">Admin</p>
                </div>
                <div
                  className="ml-auto bg-gray-100 rounded-full w-8 h-8 flex justify-center items-center lg:hidden"
                  onClick={toggleTabNavigation}
                >
                  <MdKeyboardDoubleArrowLeft className="text-gray-600 text-lg cursor-pointer" />
                </div>
              </div>
            )}
            {role2 === "dietitian".toLowerCase()
              ? clientMsg.map((item, index) => (
                <div
                  key={index}
                  className="p-2 flex items-center border border-white justify-between
                     cursor-pointer text-secondary hover:bg-secondary hover:text-white"
                  onClick={() => handleClickMessage(item.name)}
                >
                  <img
                    src={item.img}
                    className="w-12 h-12 rounded-full"
                    alt={item.name}
                  />
                  <p className=" font-semibold">{item.name}</p>
                  <BiMessageDetail className="w-6 h-6" />
                </div>
              ))
              : tabs.map((tab: any, index: Number) =>
                !tab || !Object.keys(tab).length ? (
                  <React.Fragment key={`${index}`}></React.Fragment>
                ) : tab.subItems ? (
                  // Render expandable item with subItems
                  <div key={`${index}-parent`} className="pb-1">
                    <li
                      className={`text-sm font-medium cursor-pointer flex items-center justify-between p-3 rounded-md text-gray-600 hover:bg-gray-50`}
                      onClick={() => toggleExpanded(`${index}`)}
                    >
                      <div className="flex items-center gap-3">
                        {tab.title}
                      </div>
                      {expandedItems[`${index}`] ? (
                        <FaChevronDown className="w-3 h-3 text-gray-400" />
                      ) : (
                        <FaChevronRight className="w-3 h-3 text-gray-400" />
                      )}
                    </li>
                    {expandedItems[`${index}`] && (
                      <div className="ml-4 pl-2 border-l border-gray-100">
                        {tab.subItems.map((subItem: any, subIndex: number) =>
                          subItem.subItems ? (
                            // Handle nested subItems
                            <div
                              key={`${index}-${subIndex}-nested`}
                              className="pb-1"
                            >
                              <li
                                className={`text-sm cursor-pointer flex items-center justify-between p-2 text-gray-500 hover:text-gray-900 rounded-md`}
                                onClick={() =>
                                  toggleExpanded(`${index}-${subIndex}`)
                                }
                              >
                                <div className="flex items-center">
                                  {subItem.title}
                                </div>
                                {expandedItems[`${index}-${subIndex}`] ? (
                                  <FaChevronDown className="w-3 h-3 text-gray-400" />
                                ) : (
                                  <FaChevronRight className="w-3 h-3 text-gray-400" />
                                )}
                              </li>
                              {expandedItems[`${index}-${subIndex}`] && (
                                <div className="ml-4">
                                  {subItem.subItems.map(
                                    (
                                      nestedItem: any,
                                      nestedIndex: number,
                                    ) => (
                                      <div
                                        key={`${index}-${subIndex}-${nestedIndex}`}
                                        className="pb-1"
                                        onClick={() => {
                                          handleTabChange(nestedItem.query);
                                          setSrc("");
                                        }}
                                      >
                                        <li
                                          className={`text-sm cursor-pointer flex items-center justify-between ${nestedItem.query === currentTab
                                              ? "text-[#008060] font-semibold"
                                              : "text-gray-500"
                                            } p-2 hover:text-[#008060]`}
                                        >
                                          {nestedItem.title}
                                        </li>
                                      </div>
                                    ),
                                  )}
                                </div>
                              )}
                            </div>
                          ) : (
                            // Handle regular subItems
                            <div
                              key={`${index}-${subIndex}`}
                              className="pb-1"
                              onClick={() => {
                                handleTabChange(subItem.query);
                                setSrc("");
                              }}
                            >
                              <li
                                className={`text-sm cursor-pointer flex items-center justify-between ${subItem.query === currentTab
                                    ? "text-[#008060] font-semibold"
                                    : "text-gray-500"
                                  } p-2 hover:text-[#008060]`}
                              >
                                {subItem.title}
                              </li>
                            </div>
                          ),
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  // Render regular item without subItems (e.g. Dashboard)
                  <div
                    key={tab.query}
                    className="pb-2"
                    onClick={() => {
                      handleTabChange(tab.query);
                      setSrc("");
                    }}
                  >
                    <li
                      className={`text-sm font-medium cursor-pointer flex items-center justify-between p-3 rounded-md transition-colors ${tab.query === currentTab
                          ? "bg-[#008060] text-white hover:bg-[#006b50]"
                          : "text-gray-600 hover:bg-gray-50"
                        }`}
                    >
                      {tab.title}
                    </li>
                  </div>
                ),
              )}
          </div>
          {role2 === "dietitian".toLowerCase() && (
            <section className="bg-gradient-to-r from-secondary to-[#92E3A9] text-white p-3 my-3 text-center rounded-3xl">
              <p className="text-sm w-2/3 mx-auto">Contact Customer Care</p>
              <button
                type="button"
                className="text-secondary w-11/12 my-2 text-sm rounded-full  bg-white p-1"
              >
                Contact Now
              </button>
            </section>
          )}
          <div className="mt-auto flex flex-col mb-4">
            <div
              onClick={() => setShowChangePassword((prev) => !prev)}
              className="flex items-center mb-2 gap-3 text-gray-500 text-sm font-medium py-2 px-3 cursor-pointer hover:bg-gray-50 rounded-md"
            >
              <TbArrowsExchange className="w-5 h-5" />
              <p>Change Password</p>
            </div>
            {adminLevel === "superadmin" ? (
              <button
                className="flex items-center mb-2 gap-3 text-gray-500 text-sm font-medium py-2 px-3 cursor-pointer hover:bg-gray-50 rounded-md w-full text-left"
                onClick={() => setSrc("https://food-bank-web-a-pp.vercel.app")}
              >
                <GoMoveToEnd className="w-5 h-5" />
                Go to Web Application
              </button>
            ) : role && role.some((data: any) => data.role === "Web App") ? (
              <button
                className="flex items-center mb-4 gap-2 rounded-md text-sm font-semibold py-3 px-1 border-2"
                onClick={() => setSrc("https://food-bank-web-a-pp.vercel.app")}
              >
                <GoMoveToEnd className="w-6 h-6" />
                Go to Web Application
              </button>
            ) : null}
            <div
              onClick={openModal}
              className="bg-[#ECE9F1] flex items-center mb-4 rounded-md text-sm py-3 px-1 cursor-pointer border-2 "
            >
              <TbLogout2 className="w-6 h-6" />
              <span className="pl-4">Log Out</span>
            </div>
            <div className="flex items-start flex-col xl:flex-row">
              <div>
                <h1 className="font-semibold capitalize">{fullName}</h1>
                <p className="text-gray-600 text-xs">{userEmail}</p>
                {adminLevel && (
                  <p className="text-gray-400 text-xs mt-1 capitalize">
                    {adminLevel}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </ul>
      {showMessageBox && (
        <DietitianMessage
          setShowMessageBox={setShowMessageBox}
          clientName={clientName}
        />
      )}
      {showChangePassword && (
        <ChangePassword setShowChangePassword={setShowChangePassword} />
      )}
    </>
  );
};

export default SideBar;
